import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import { Suspense, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { SettingsCache } from '~/lib/consts/settings-cache';
import DesktopTitledLayout from './desktop-layout';
import MobileLayout from './mobile-layout';
import Navvy from './navvy';

// PrePay area (account experience). Same underline-tab pattern as the Account
// area: PrePay & Balance plus - behind the 'AutoTopUp' feature flag - Auto
// Top-Up. With the flag off Navvy renders nothing (single tab), so the page
// looks identical to the old standalone PrePay page.
export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { t } = useTranslation(TranslationNamespaces.PREPAY);

  const routes = useMemo(() => {
    const output = [RoutingConstants.PrePay];
    if (SettingsCache.settings.Features.includes('AutoTopUp')) {
      output.push(RoutingConstants.AutoTopUp);
    }
    return output;
  }, []);

  const labels = useMemo(
    () => ({
      [RoutingConstants.PrePay]: t('PREPAY_TAB_BALANCE', { defaultValue: 'PrePay & Balance' }),
      [RoutingConstants.AutoTopUp]: t('PREPAY_TAB_AUTO_TOPUP', { defaultValue: 'Auto Top-Up' })
    }),
    [t]
  );

  if (isXs) {
    return (
      <MobileLayout>
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout title={t('PREPAY_AREA_TITLE', { defaultValue: 'PrePay & Balance' })}>
      <Suspense>
        <Navvy routes={routes} prefix="PREPAY" labels={labels} />
      </Suspense>
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'PrePay';
